import { useState } from 'react';
import { DateRange } from 'react-day-picker';
import { 
  calculateDateRange, 
  getCurrentMonthRange, 
  getLastMonthRange 
} from '../../../../utils/date/dateUtils';

export type QuickDateType = 'today' | 'yesterday' | 'week' | 'month' | 'thisMonth' | 'lastMonth';

interface UseDateSelectionProps {
  onDateRangeUpdate: (startDate: Date, endDate: Date) => Promise<void>;
}

export const useDateSelection = ({ onDateRangeUpdate }: UseDateSelectionProps) => {
  const [showDatePicker, setShowDatePicker] = useState(false);

  // 날짜 범위 변경 핸들러 (실시간 변경)
  const handleDateRangeChange = (range: DateRange) => {
    // 실시간 변경은 UI 업데이트만 하고 데이터 조회는 하지 않음
    // setDateRange는 store에서 직접 호출
  };

  // 달력 확인 핸들러 (확인 버튼 클릭 시 데이터 조회)
  const handleDateConfirm = async (range: DateRange) => {
    if (range.from && range.to) {
      setShowDatePicker(false);
      await onDateRangeUpdate(range.from, range.to);
    }
  };

  // 달력 취소 핸들러
  const handleDateCancel = () => {
    setShowDatePicker(false);
  };

  // 빠른 날짜 계산 로직
  const calculateQuickDate = (type: QuickDateType): { fromDate: Date; toDate: Date } => {
    const now = new Date();
    
    switch (type) {
      case 'today':
        return { fromDate: new Date(now), toDate: new Date(now) };
      case 'yesterday':
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        return { fromDate: yesterday, toDate: new Date(yesterday) };
      case 'week':
        return calculateDateRange(7);
      case 'month':
        return calculateDateRange(30);
      case 'thisMonth':
        return getCurrentMonthRange();
      case 'lastMonth':
        return getLastMonthRange();
      default:
        return { fromDate: new Date(now), toDate: new Date(now) };
    }
  };

  // 빠른 날짜 선택 핸들러
  const handleQuickDateSelect = async (type: QuickDateType) => {
    const { fromDate, toDate } = calculateQuickDate(type);
    await onDateRangeUpdate(fromDate, toDate);
  };

  // 날짜 범위 선택 모달 열기
  const openDatePicker = () => {
    setShowDatePicker(true);
  };

  return {
    showDatePicker,
    handleDateRangeChange,
    handleDateConfirm,
    handleDateCancel,
    handleQuickDateSelect,
    openDatePicker,
    calculateQuickDate
  };
}; 